import React, { Component } from 'react';
import { TextField } from '@material-ui/core';
import { validatePhoneNumber, WrongPhoneNumberFormatText } from '../Auth/Common';

type Props = {
    value: string,
    onChange: (value: string, isValid: boolean) => void
    onBlur?: () => void,
    variant?: any,
    label?: string
}

type State = {
    phoneNumberFormatError: boolean,
}

class PhoneNumberInput extends Component<Props, State> {
    constructor(props: Props){
        super(props)

        this.state = {
            phoneNumberFormatError: false,
        }
    }
    render() {
        return (
            <TextField
            onChange={(e) => {
                let isValid = validatePhoneNumber(e.target.value)
                this.setState({ phoneNumberFormatError: !isValid })
                this.props.onChange(e.target.value, isValid)
            }}
            value={this.props.value}
            onBlur={this.props.onBlur}
            label={this.props.label || "Phone Number"} 
            margin="normal"
            variant={this.props.variant || "outlined"}
            style={{ width: '100%' }}
            helperText={this.state.phoneNumberFormatError ? WrongPhoneNumberFormatText : ''}
            error={this.state.phoneNumberFormatError}
        ></TextField>        );
    }
}

export default PhoneNumberInput;
